import ObjectivesAndIncentives from './ObjectivesAndIncentives';

export default ObjectivesAndIncentives;
